import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../../index.css";

import { createCheckoutSession } from "../../third-party-services";
import {
  FunctionsHttpError,
  FunctionsRelayError,
  FunctionsFetchError,
} from "@supabase/supabase-js";
import { useSupabaseApp } from "../../SupabaseApp";

import "./payment-modal.css";

export default function OrderFormModal({
  show,
  onHide,
  captchaCompleted,
  captchaToken,
}) {
  const { supabase } = useSupabaseApp();
  // This modal is ONLY for the Premium annual plan
  const plan = "pro";
  const billing = "annually";

  async function handleSubmit() {
    try {
      const { data, error } = await supabase.functions.invoke(
        "subscribeToAPlan",
        {
          body: JSON.stringify({
            billing,
            plan,
            captchaToken,
            gclid: localStorage.getItem("gclid"),
          }),
        },
      );

      if (error instanceof FunctionsHttpError) {
        const errorMessage = await error.context.json();

        throw new Error(
          errorMessage?.message ||
          errorMessage?.error ||
          JSON.stringify(errorMessage),
        );
      }

      if (error instanceof FunctionsRelayError) {
        throw new Error(error.message);
      }

      if (error instanceof FunctionsFetchError) {
        throw new Error(error.message);
      }

      // subscribeToAPlan returns the Stripe Checkout Session ID
      const sessionId = data;

      // Redirect to Stripe Checkout
      await createCheckoutSession(sessionId);
    } catch (error) {
      console.error("Subscription error:", error);

      alert(
        error?.message ||
        "Something went wrong while creating your subscription.",
      );
    }
  }

  return (
    <Modal
      className="orderdiv"
      show={show}
      onHide={onHide}
      size="lg"
      backdrop="static"
      fullscreen="sm-down"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="orderheader" />

      <Modal.Body className="orderbody">
        {/* Progress */}
        <div className="orderprogressdiv">
          <div className="orderprogressitem">
            <img
              src="/payment/green-check.png"
              alt=""
              className="ordercheckicon"
            />
            <span>PRICING</span>
          </div>

          <div className="orderprogressitem">
            <img
              src="/payment/green-number2.png"
              alt=""
              className="ordercheckicon"
            />
            <span>ORDER</span>
          </div>

          <div className="orderprogressitem">
            <img
              src="/payment/grey-number3.png"
              alt=""
              className="ordercheckicon"
            />
            <span style={{ color: "#808080" }}>PAYMENT</span>
          </div>
        </div>

        {/* Title */}
        <p
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            paddingTop: "5%",
          }}
        >
          roiquant premium plan - review and upgrade
        </p>

        {/* Plan */}
        <div className="orderbuttondiv">
          <button className="orderbuttonclicked" disabled>
            <p
              style={{
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              Yearly plan
            </p>

            <p
              style={{
                marginBottom: "0",
                textAlign: "left",
                marginLeft: "1rem",
              }}
            >
              <span
                style={{
                  fontFamily: "AileronRegular",
                  fontWeight: "bold",
                }}
              >
                USD $300 per user / year
              </span>
              <br />
              (Billed annually: $25 per user / month)
            </p>

            <p
              style={{
                textAlign: "left",
                marginLeft: "1rem",
              }}
            >
              <br />

              <span>3,000 monthly API requests included</span>

              <br />

              <span>For additional API request: $0.001 per request</span>
            </p>
          </button>
        </div>

        {/* Important note */}
        <div style={{ paddingTop: "2.5%" }}>
          <p style={{ fontWeight: "bold" }}>
            Important note: confirm your subscription order
          </p>

          <p>
            Once payment is made,{" "}
            <a
              href="https://viewpoints.roiquant.com/refund-policy#all-payments-are-non-refundable"
              className="orderlink"
              target="_blank"
              rel="noopener noreferrer"
            >
              there is no refund
            </a>
            .
          </p>

          <p>
            However, you may cancel your subscription anytime to stop the
            recurring billing and payment.
          </p>
        </div>

        {/* Legal */}
        <div className="extranote">
          <span>
            By clicking the 'Upgrade now' button below, you agree to roiquant's{" "}
            <a
              href="https://viewpoints.roiquant.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              privacy policy
            </a>
            ,{" "}
            <a
              href="https://viewpoints.roiquant.com/how-do-we-use-cookies/"
              target="_blank"
              rel="noopener noreferrer"
            >
              cookies
            </a>
            ,{" "}
            <a
              href="https://viewpoints.roiquant.com/user-notice/"
              target="_blank"
              rel="noopener noreferrer"
            >
              user notice
            </a>
            ,{" "}
            <a
              href="https://viewpoints.roiquant.com/refund-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              refund policy
            </a>{" "}
            and{" "}
            <a
              href="https://viewpoints.roiquant.com/terms-of-service/"
              target="_blank"
              rel="noopener noreferrer"
            >
              terms of service
            </a>
            .
          </span>
        </div>

        {/* Order total */}
        <p
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            paddingTop: "5%",
          }}
        >
          Order total: USD $300.00
        </p>

        {/* Buttons */}
        <div style={{ textAlign: "center" }}>
          <button type="button" className="ordercancelbutton" onClick={onHide}>
            Cancel
          </button>

          <button
            type="button"
            className="orderbutton glintanimation"
            onClick={handleSubmit}
          >
            Upgrade now
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
